module.exports = __webpack_public_path__ + "img/KSC07248.65f97a54.jpg";